// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"eeae8ff1","480":"ab5fb9e6"}[chunkId] + ".chunk.js";
};